import { render, staticRenderFns } from "./TechnicalEdit.vue?vue&type=template&id=72c150c4&"
import script from "./TechnicalEdit.vue?vue&type=script&lang=js&"
export * from "./TechnicalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports